import * as React from 'react';
import { useSelector } from 'react-redux';

import { userIdSelector } from '../../../selectors';
import { EChatRole, IUserInChatListSchema } from '../../../types/userData';

type TUseLastMessageName = {
  users: IUserInChatListSchema[];
  lastMessageUserId: number;
};

export const useLastMessageName = ({ users, lastMessageUserId }: TUseLastMessageName): string | undefined => {
  const userId = useSelector(userIdSelector);

  const currentUser = users.find(user => user.userId === userId);
  const messageUser = users.find(user => user.userId === lastMessageUserId);

  return React.useMemo(() => {
    // Если в чате два юзера - имя в чате в списке чатов не отображаем
    if (users.length <= 2) {
      return undefined;
    }

    // Если зашли за инициатора - имя не отображаем
    if (currentUser?.chatRole === EChatRole.Initiator) {
      return undefined;
    }

    if (lastMessageUserId === userId) {
      return 'Вы:';
    }

    return messageUser?.name ? `${messageUser.name}:` : `id ${messageUser?.userId}:`;
  }, [currentUser?.chatRole, lastMessageUserId, messageUser?.name, messageUser?.userId, userId, users.length]);
};
